export default "__VITE_ASSET__Cb7_Qjpk__"